import React from 'react'

export type UI2Platform = 'desktopWeb' | 'mobileWeb'

/**
 * Identifies which platform a UI2 component is rendering on.
 *
 * Defaults to `desktopWeb`; the `withUI2MobileWeb` HOC — applied to every
 * component in the mobile-web UI2 registry — overrides it to `mobileWeb`.
 *
 * Consumed by UI2 components that swap control mode based on platform (e.g.
 * bottom sheet vs. tethered popover). Styling-only differences should key off
 * the ambient `ui2--mobileWeb` class instead.
 */
export const UI2PlatformContext = React.createContext<UI2Platform>('desktopWeb')

export const useUI2Platform = (): UI2Platform => React.useContext(UI2PlatformContext)
